import instance, { BASE_URL } from "../../services/api";
import toast from "react-hot-toast";
import fileDownload from "js-file-download";

const PayrollViewController = () => {
  //   const getErrorMessage = (error) => {
  //   return (
  //     error.response?.data?.detail ||   // Django REST Framework style
  //     error.response?.data?.message ||  // custom backend message
  //     error.response?.data?.error ||    // another fallback
  //     error.message ||                  // Axios default
  //     "Something went wrong!"
  //   );
  // };
   


  const getPayslip = (employeeId, month, year, EMP_id) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.get(
        `${BASE_URL}generate-salary-slip/${employeeId}/${month}/${year}/`,
        {
          responseType: "blob", // Important to handle PDF
        }
      );
      
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `payslip_${EMP_id}_${month}_${year}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch({
        type: "GET_SALARY_SLIP_SUCCESS",
        payload: "Payslip downloaded successfully",
      });
    } catch (error) {
      dispatch({ type: "GET_SALARY_SLIP_FAILURE", payload: false });
      console.error("Error generating payslip:", error);
      dispatch({ type: "ERROR", payload: "Failed to generate payslip" });
    }
  };

  const getEmployeePayroll = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}set-salary/`);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_EMPLOYEE_SALARY_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_SALARY_FAILURE",
        payload: { error: error },
      });
      // toast.error(message);
    }
  };

  const getEmployeePaySlip = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}salary-slips/`);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_EMPLOYEE_SALARY_SLIP_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_SALARY_SLIP_FAILURE",
        payload: { error: error },
      });
      // toast.error(message);
    }
  };

  const addPayRoll = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(`${BASE_URL}salary-slips/`, reqData);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_PAYROLL_SUCCESS", payload: data });
      dispatch(getEmployeePaySlip());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Payroll added sucessfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const backendMessage =
        error.response?.data?.detail || // <-- this captures your new error
        error.response?.data?.non_field_errors?.[0] ||
        (error.response?.data?.detail ===
        "Salary slips already exist for all selected employees for this month."
          ? "Salary slips already generated for all selected employees."
          : null) ||
        "Something went wrong. Please try again!";

      toast.error(backendMessage);
      dispatch({
        type: "ADD_PAYROLL_FAILURE",
        payload: error,
      });
      throw error;
    }
  };

  const deletePayroll = (payrollId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}salary-slips/${payrollId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_PAYROLL_SUCCESS", payload: data });
      dispatch(getEmployeePaySlip());
      dispatch(getEmployeePayroll());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Payroll deleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_PAYROLL_FAILURE",
        payload: { error: error },
      });
      toast.error(error);
    }
  };

  const genrateSalaryReport = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.post(
        `${BASE_URL}salary-report/download/`,
        reqData,
        {
          responseType: "blob", // important to get binary data
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Use month to name the file
      const startDate = reqData.start_date || "start";
      const endDate = reqData.end_date || "end";

      // Optional: clean up to avoid characters that can break filenames
      const clean = (date) => date.replace(/[:\s]/g, "-");

      const filename = `Salary_Report_${clean(startDate)}_to_${clean(
        endDate
      )}.xlsx`;

      // Download file
      fileDownload(response.data, filename);

      dispatch({ type: "GENRATE_SALARY_REPORT_SUCCESS" });
    } catch (error) {
      dispatch({
        type: "GENRATE_SALARY_REPORT_FAILURE",
        payload: { error },
      });
      //  const message = getErrorMessage(error);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      // toast.error(message);
    }
  };

  return {
    getPayslip,
    addPayRoll,
    getEmployeePayroll,
    getEmployeePaySlip,
    genrateSalaryReport,
    deletePayroll,
  };
};

export default PayrollViewController;
